
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shipper/shipperguide",
      function () {
        return require("private-next-pages/shipper/shipperguide/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shipper/shipperguide"])
      });
    }
  